import * as Proxy from './Proxy'

export default (function () {
    return {
        ReturnToAmbit() {
            return Proxy.Redirect('http://www.int.ambitenergy.io', 'https://www.ambitenergy.com');
        }
    };
})()